module.exports = __webpack_public_path__ + "img/map.97a2564d.svg";